import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getAllData, deleteIdData } from "../../../lib/collegerank";

export default function AdminDesiredColleges() {
  const [colleges, setColleges] = useState([]);
  const [filteredColleges, setFilteredColleges] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  // Handle search query and filter resources
  useEffect(() => {
    const filterData = () => {
      const filtered = colleges.filter((college) => {
        return college.collegename
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
      });
      setFilteredColleges(filtered);
    };

    filterData();
  }, [searchQuery, colleges]);

  const handleDelete = async (id) => {
    const choice = window.confirm("Are You Sure?");
    if (choice) {
      await deleteIdData(id);
      GetData();
      console.log("Delete", id);
      //router.refresh();
    }
  };

  async function GetData() {
    const collegs = await getAllData();
    setColleges(collegs);
    setFilteredColleges(collegs);
    console.log("collegs", collegs);
  }

  useEffect(() => {
    GetData();
  }, []);
  const essentialheader = (name, buttonname, buttonlink) => {
        return (
          <div className="d-flex p-2 justify-content-between align-items-center">
            <div className="d-flex p-2">
              <h3>{name}</h3>
              <p></p>
            </div>
            <div className="d-flex">
              <div className="ticket-btn-grp">
                    <Link
                      to={buttonlink}
                    >
                      {buttonname}
                    </Link>
                </div>
              </div>
          </div>
      );
    }
  return (
    <div className="col-xl-12 col-md-12">
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-0">
          {essentialheader(
            "Desired Colleges",
            "Create New College",
            "/admin/admin-desiredcolleges-edit/Add"
          )}
            <div className="d-flex justify-content-start ms-3">
              <input
                type="text"
                className="form-control w-25 me-2"
                placeholder="Search colleges..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ border: "1px solid #808080" }}
              />
          </div>
          <div className="comman-space pb-0">
            <div className="settings-invoice-blk table-responsive">
              {/* Invoice info */}
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Id</th>

                    <th>Parameter</th>
                    <th></th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredColleges.map(function (data) {
                    return (
                      <tr key={data.id}>
                        <td>
                          <Link to="#" className="invoice-no">
                            {data.id}
                          </Link>
                        </td>

                        <td>{data.collegename}</td>
                        <td></td>
                        <td>
                          <div className="profile-share d-flex align-items-center justify-content-end">
                            <Link
                              to={`/admin/admin-desiredcolleges-edit/${data.id}`}
                              className="btn btn-success btn-sm"
                            >
                              Update
                            </Link>
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => handleDelete(data.id)}
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {/* Invoice info */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
